import { Injectable } from '@angular/core';

import { JwtHelperService } from "@auth0/angular-jwt";
import { MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser';

@Injectable({ 
	providedIn: 'root',
})
export class TokenService {

	private readonly scopes = ['User.Read', 'api://3862a48e-f645-4681-9a4d-c0d590e58e74/read'];

	constructor(private msalService: MsalService) {}

	public async hasAdminRole(): Promise<boolean> {
		const decodedToken = await this.getDecodedAccessToken();
		if (!decodedToken) return false;

		const roles: string[] = decodedToken['roles'] || decodedToken['role'] || [];
		return roles.some(role => role.toLowerCase() === 'administrators');
	}

	public async isAuthenticated(): Promise<boolean> {
		const decodedToken = await this.getDecodedAccessToken();
		return !!decodedToken;
	}

	private async getDecodedAccessToken(): Promise<any | null> {
		const activeAccount: AccountInfo | null = this.msalService.instance.getActiveAccount();

		if (!activeAccount) return null;

		try {
			const token = await this.msalService.instance.acquireTokenSilent({
				account: activeAccount,
				scopes: this.scopes,
			});	

			if (token && token.account.idToken) {
				const helper = new JwtHelperService();
				return helper.decodeToken(token.account.idToken);
			}
		} catch (error) {
			if (error instanceof InteractionRequiredAuthError) {
				console.warn('User interaction required for token acquisition.');
			} else {
				console.error('Error acquiring token:', error);
			}
		}

		return null;
	}
}